import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('g', { id: 'Artboard-32' }),
  React.createElement('polygon', { points: '16.65 9.84 15.35 9.84 15.35 15.35 9.84 15.35 9.84 16.65 15.35 16.65 15.35 22.16 16.65 22.16 16.65 16.65 22.16 16.65 22.16 15.35 16.65 15.35 16.65 9.84' }),
  React.createElement('path', { d: 'M23.14,3.64H8.86L1.72,16,8.86,28.36H23.14L30.28,16Zm-.75,23.42H9.61L3.23,16,9.61,4.94H22.39L28.78,16Z' })
));